import Store from "App/Store.js";

export default (Access, AccessReason) => Store.dispatch({type: "access", Access, AccessReason: (!Access ? AccessReason : null)});
